export default {
  // ProfilePage.vue
  profilePage: {
    title: 'My Profile',
    version: 'Version:',

    musicalInformation: {
      subtitle: 'My musical information',
      myMaterial: 'My equipment',
      displayMode: 'Display mode',
      level: 'Level',
      learningPath: 'Learning Path',
      handSize: 'Hand size',
      myVoice: 'My voice',
    },

    educationalFollowUp: {
      subtitle: 'Educational follow-up',
      myTeacher: 'My piano teacher',
      myGoals: 'My goals',
      scheduledSessions: 'My scheduled sessions',
    },

    accountManagement: {
      subtitle: 'Account management',
      language: 'Interface language',
      newsletterSubscription: 'Newsletter subscription',
      receiveTeacherNotifications: 'Receive teacher notifications',
      passwordChange: 'Password change',
      deleteAccount: 'Delete account',
    },

    legalInformation: {
      subtitle: 'Legal information',
      termsOfUse: 'Terms of use',
      termsOfSale: 'Terms of sale',
      gdprRequests: 'Other GDPR requests',
      contact: 'Contact',
    },

    actions: {
      reviewTutorial: 'Review tutorial',
      logout: 'Logout',
      cancel: 'Cancel',
      yes: 'Yes',
    },

    deleteAccountDialog: {
      title: 'Delete account',
      question: 'Do you really want to delete your account?',
      warning: 'You will have 14 days to recover your account. After this period, it will no longer be possible to recover it.',
    },

    notifications: {
      choiceSaved: 'We have saved your choice',
      errorOccurred: 'A problem occurred, please try again later...',
      notificationsEnabled: 'Great, we will send you notifications',
      notificationsDisabled: 'You will no longer receive notifications',
      goalsSaved: 'I have noted your new goals!',
    },
  },

  languageSelector: {
    title: 'Language',
    subtitle: 'Choose the interface language',
    available: 'Available languages',
    changed: 'Language changed successfully',
  },

  // AccountDeleted.vue
  accountDeletedPage: {
    title: 'You have deleted your account',
    deleted: 'Your account has been successfully deleted. You have 14 days to recover your account. After this period, it will no longer be possible to recover it.',
    recovery: 'To recover your account, please refer to the email you received.',
    contact: 'We remain at your disposal for any questions.',
    regards: 'Best regards,',
    team: 'The Tokatab team',
    backButton: 'Back',
  },

  // ChangeUserLevelModal.vue
  changeUserLevelModal: {
    title: 'Do you think this level is not suitable for your profile?',
    description: 'Explain your problem to us, we will try to help you!',
    issueLabel: 'What is your problem?',
    issueRequired: 'This field is required',
    detailsPlaceholder: 'Give us more details...',
    detailsRequired: 'Please give us more details before changing your level',
    askForTeacherContact: 'I would like to be contacted by a teacher.',
    cancel: 'Cancel',
    changeLevel: 'I change level',
    issues: {
      tooEasy: 'Too easy',
      tooHard: 'Too hard',
      tooLong: 'Too long',
      notAdapted: 'Not suitable',
    },
    notifications: {
      alreadyMaxLevel: 'You are already at the most advanced level! We regularly feed our site with new modules. In the meantime you can practice by playing challenges or songs!',
      levelIncreased: 'We have changed your level to the higher level! Happy learning!',
      alreadyMinLevel: 'We cannot offer you simpler content, if you have difficulties, try to resume the first exercises.',
      alreadyMinLevelWithTeacher: 'You have asked to be contacted by a teacher, we will try to contact you as soon as possible. Check your emails.',
      alreadyMinLevelNeedMore: 'For more help, you can add information and ask to be contacted by a teacher.',
      levelDecreased: 'We have changed your level to the lower level! Happy learning!',
      feedbackTooLong: 'Thank you for your feedback, if you asked to be contacted, we will try to get back to you! In the meantime you can try challenges or songs for a change!',
      feedbackGeneral: 'Thank you for your feedback, if you asked to be contacted, we will try to get back to you! In the meantime you can try challenges or songs.',
    },
  },

  // SubscribePage.vue
  subscribePage: {
    loadingPrices: 'Loading prices...',
  },

  // ProductStep.vue (PlanStep)
  subscribeProductStep: {
    subscribeToTokatab: 'Subscribe to Tokatab Premium and unlock your full piano potential',
    subscribeButton: 'See plans',
    tagline: 'Unlock the full piano experience',
  },

  // ProductCarousel.vue
  subscribeProductCarousel: {
    slide1: {
      title: 'Your virtual teacher always in your pocket',
      description: 'An app that understands you, accompanies you and motivates you to progress regularly on the piano.',
    },
    slide2: {
      title: 'Over 1000 exercises and videos',
      description: 'Tokatab builds you a 100% personalized educational path.',
    },
    slide3: {
      title: 'Challenges to progress',
      description: 'No time for a long session? Our challenges will allow you to apply new techniques in just a few minutes.',
    },
    slide4: {
      title: 'Our users speak better than us!',
      description: 'The app is super motivating. I had stopped playing piano, and thanks to Tokatab I rediscovered the pleasure of playing.',
      author: 'Adèle',
    },
  },

  // PriceStep.vue
  subscribePriceStep: {
    title: 'Thanks to Tokatab Premium',
    desktopTitle: 'With Tokatab Premium, get unlimited access to',
    chooseYourPlan: 'Choose your plan',
    perMonth: '/month',
    perYear: '/ year',
    soit: 'i.e.',
    oneTime: 'one-time payment',
    billedAnnually: 'billed {amount}/year',
    richFeatures: {
      f1: { title: 'Full song catalogue', sub: 'Hundreds of pieces for every skill level' },
      f2: { title: '1,000+ exercises & videos', sub: 'A 100% personalized learning path' },
      f3: { title: 'Personalized recommendations', sub: 'Content tailored to your level and taste' },
      f4: { title: 'Real-time MIDI feedback', sub: 'Connect your piano and get instant feedback' },
      f5: { title: 'Import your sheet music', sub: 'Work on your own pieces directly in Tokatab' },
      f6: { title: 'Virtual teacher 24/7', sub: 'A coach available whenever you need one' },
    },
    features: {
      unlimited: "Unlimited use of Tokatab",
      features: "Get full access to all Premium features, with no restrictions:",
      courses: "<strong>1,000+ exercises</strong>, personalized recommendations, full songs, challenges, <strong>guided reviews</strong>…",
      skills: "👉 Build your skills at your own pace.",
      import1: "📁 Import as many of your own sheet music files as you like",
      import2: "👉 Import as many sheet music pieces as you like and work through them step by step directly in Tokatab.",
      community1: "💬 Private subscriber community",
      community2: "Join a WhatsApp group exclusively for subscribers to chat live with the Tokatab team and other <strong>piano fans.</strong>",
      bullet1: '1,000+ exercises & complete songs',
      bullet2: 'Personalized path & guided reviews',
      bullet3: 'Import your own sheet music',
      bullet4: 'Challenges & skills',
    },
    cancel: 'Cancel',
    confirm: 'Start now',
  },

  // PriceCard.vue
  subscribePriceCard: {
    premiumTitle: 'Tokatab Premium',
    bestValue: 'Best value',
    planTypes: {
      annual: 'annual',
      threeMonth: 'quarterly',
      lifetime: 'lifetime',
      monthly: 'monthly',
    },
    subscribeButtons: {
      annual: 'Subscribe for one year',
      threeMonth: 'Subscribe for three months',
      lifetime: 'Subscribe for life',
      monthly: 'Subscribe for one month',
    },
    renewalInfo: {
      annual: 'automatically renewed every year',
      threeMonth: 'automatically renewed every quarter',
      monthly: 'automatically renewed every month',
      lifetime: 'one-time payment, lifetime access',
    },
  },

  // SubscribeSuccessPage.vue
  subscribeSuccessPage: {
    premiumTitle: 'Tokatab Premium',
    congratulations: 'Congratulations ✨',
    trial: {
      title: 'The trial period has been successfully activated!',
    },
    success: {
      title: 'Payment is successful!',
      message: 'Your subscription may take a few minutes to activate.',
    },
    letsGo: "Let's go",
  },

  // EarlyAccessPage.vue
  earlyAccessPage: {
    backToHome: 'Back to home',
    title: 'Bravo!',
    message: 'You are among the <b>very first people</b> to have clicked on this button! Thank you for your <b>trust</b> and your <b>motivation</b>!<br>The premium offer of Tokatab will be available very soon. We are currently in discussion with copyright managers to make this possible.<br>In the meantime, would you be interested in having <b>limited time access</b> to a test version of <b>the premium offer</b> as a <b>tester</b>? There are still a few places left!<br><br>If yes, you just need to <b>answer the questionnaire</b> by clicking on the button below, it will take you 5 minutes max!',
    surveyButton: 'I answer and enjoy Tokatab for free!',
  },

  // TrialModal.vue
  trialModal: {
    trialEnded: {
      title: 'Thank you for trying',
      premium: 'Tokatab Premium',
      subtitle: 'Your trial period is over!',
      question: 'Can you tell us what you thought of Tokatab?',
      ratingLabels: {
        dislike: "I didn't like it",
        love: 'I loved it',
      },
      noOpinion: "I have no opinion",
      validate: 'Validate',
    },
    review: {
      title: 'Thank you for trying',
      premium: 'Tokatab Premium',
      highRating: {
        text1: 'We are delighted that you like Tokatab!',
        text2: 'Every day, we do our best to provide you with the best app to learn piano.',
        text3: 'Great things are coming, we would be happy to continue to accompany you in your learning.',
      },
      mediumRating: {
        text1: 'We are delighted that you like Tokatab!',
        text2: 'Every day, we do our best to provide you with the best app to learn piano.',
        text3: 'Great things are coming, we would be happy to continue to accompany you in your learning.',
        text4: 'For this, we now offer you a -30% offer on the annual subscription.',
      },
      lowRating: {
        text1: 'Oops!! Road accident for the Tokatab team...',
        text2: 'We do our best to build the best piano learning app but it seems we still have work to do to satisfy you.',
        text3: 'Can you tell us more about what you disliked?',
      },
      placeholder: 'Write your comment',
      buttons: {
        subscribe: 'Subscribe',
        discount: 'Take advantage of the -30% offer',
        continue: 'Continue',
        discoverPlans: 'Discover subscription plans',
      },
    },
    reviewSent: {
      thanks: 'Thank you for your feedback.',
      message: 'We continuously improve the app. We leave you access to a limited version to continue using Tokatab and see these improvements.',
      continue: 'Continue',
    },
    extensionRequired: {
      premium: 'Tokatab Premium',
      title: 'Your trial period is over!',
      message: 'It seems you have used Tokatab little. So that you can better know the app, we offer you the possibility to extend your trial period by {days} additional days!',
      subscribe: 'Subscribe',
      extend: 'Extend my trial period',
    },
  },

  // WaitingSubscriptionModal.vue
  waitingSubscriptionModal: {
    premium: 'Tokatab Premium',
    paymentSucceeded: {
      title: 'Congratulations! ✨',
      message: 'Payment succeeded! Your subscription is activated and you can now enjoy all Tokatab features.',
    },
    trialEnabled: {
      title: 'Congratulations! ✨',
      message: 'Your trial period is activated until {date}. You will be charged on this date, unless you cancel your subscription before the end of the trial period from your profile.',
    },
    waiting: {
      text1: 'You have opened the Tokatab subscription page.',
      text2: 'If you have initiated a payment process and validated the transaction via SMS or your bank app, return to your browser to finalize your subscription validation.',
    },
    close: 'Close',
    continue: 'Continue',
  },

  // SubscriptionService.ts
  subscriptionService: {
    planTypeNames: {
      annual: 'Annual',
      lifetime: 'Lifetime',
      monthly: 'Monthly',
    },
    planTypeUnits: {
      annual: 'per year',
      lifetime: 'one time only',
      monthly: 'per month',
    },
    errors: {
      packageNotFound: 'The package does not exist. Please try again or contact support.',
      purchaseFailed: 'An error occurred during purchase. Please try again or contact support.',
    },
    success: {
      purchaseCompleted: 'Your purchase has been completed!',
    },
  },

  // UserService.ts
  userService: {
    errors: {
      cannotChangeParameter: 'You cannot change this parameter.',
    },
    freeActionsLimit: {
      daily: {
        message: 'You have exhausted your quota of free content today. Subscribe to Tokatab premium for unlimited content!',
        subscribe: 'Subscribe',
      },
      weekly: {
        message: 'You have exhausted your quota of free content this week. Subscribe to Tokatab premium for unlimited content!',
        subscribe: 'Subscribe',
      },
    },
    updateLevel: {
      notifyText: 'Congratulations! You are now at level {levelName}!',
    },
  },

  // NotificationSessionTypes.ts
  notificationSessionTypes: {
    daysLabel: {
      MON: 'monday',
      TUE: 'tuesday',
      WED: 'wednesday',
      THU: 'thursday',
      FRI: 'friday',
      SAT: 'saturday',
      SUN: 'sunday',
    },
  },

  // UserConfigurationTypes.ts
  userConfigurationTypes: {
    keyboardTypes: {
      classic: 'Non-MIDI compatible piano',
      midi: 'MIDI compatible piano',
      none: 'No piano',
    },
    keyboardTypesWithLabel: {
      acousticPiano: 'Acoustic piano',
      digitalPiano: 'Digital piano',
      midiKeyboard: 'MIDI keyboard',
      noPiano: 'No piano',
    },
    goals: {
      enjoyPlaying: 'Have fun playing',
      improveLevel: 'Improve my technique',
      discoverNewSongs: 'Discover new songs',
      getBackToPiano: 'Get back into piano',
      learnRhythms: 'Learn accompaniment patterns',
      playSingSimultaneously: 'Sing and play at the same time',
      learnSpecificSong: 'Learn a specific song',
      other: 'Other',
    },
    displayModes: {
      pianoRoll: 'Piano roll',
      partition: 'Sheet music',
    },
  },

  // UserLevelsData.ts
  userLevelsData: {
    levels: {
      novice: 'Novice',
      beginner: 'Beginner',
      beginner1: 'Beginner I',
      beginner2: 'Beginner II',
      intermediate: 'Intermediate',
      advanced: 'Advanced',
    },
  },

  // LoginPage.vue
  loginPage: {
    errors: {
      invalidCredentials: 'Error, check your email and password.',
      incorrectPassword: 'Error, your password is incorrect.',
      emailAlreadyUsed: 'This email address is already in use.',
      signupFailed: 'Your registration request could not be completed. Check your information and try again.\n',
    },
    success: {
      passwordChanged: 'Your password has been successfully changed',
    },
    form: {
      emailLabel: 'Your email',
      passwordLabel: 'Your password',
      forgotPassword: 'Forgot password?',
      loginButton: 'Sign in',
      or: 'OR',
      noAccount: "Don't have an account yet?",
      startUsing: 'Start using Tokatab',
    },
  },

  // ExternalAuthButton.vue
  externalAuthButton: {
    continueWith: 'Continue with {provider}',
    errors: {
      genericError: 'An error occurred',
    },
  },

  // ExternalRegister.vue
  externalRegister: {
    title: 'Confirm the creation of your account',
    emailLabel: 'Email Address',
    newsletterConsent: 'I agree to be informed of Tokatab news by email (we hate spam as much as you do!)',
    legalNotice: 'By clicking "Confirm", you accept',
    termsOfUse: "Tokatab's Terms of Use",
    confirmButton: 'Confirm',
    errors: {
      emailAlreadyUsed: 'This email is already used for another account.',
      genericError: 'An error occurred',
    },
  },

  // ForgotPasswordPage.vue
  forgotPasswordPage: {
    backButton: 'Back',
    tokatab: 'Tokatab',
    title: 'Did you forget your password?',
    subtitle: 'Please enter your email address,<br>we will send you a link to reset it.',
    emailLabel: 'Your email',
    sendButton: 'Send',
    errors: {
      invalidEmail: 'Error, please check your email entry',
    },
    success: {
      emailSent: 'If an account linked to this address exists, an email has been sent to: {email}',
    },
  },

  // ChangePasswordPage.vue
  changePasswordPage: {
    backButton: 'Back',
    tokatab: 'Tokatab',
    title: 'Choose your new password',
    newPasswordLabel: 'New password',
    confirmPasswordLabel: 'Confirm new password',
    validateButton: 'Validate',
    errors: {
      invalidToken: 'Error, the token to change your password is invalid',
      invalidPassword: 'Error, please check your password entry',
      passwordRequirements: 'Error, your password must contain at least: 8 characters, 1 uppercase and 1 lowercase',
      passwordMismatch: 'Error, both passwords must be identical',
    },
  },

  // FirebaseAuthenticationService.ts
  firebaseAuthenticationService: {
    errors: {
      loginFailed: 'An error occurred while connecting to {provider}',
    },
  },

  // ValidateEmailPopup.vue
  validateEmailPopup: {
    title: 'Confirm your email address',
    sentEmail: 'We sent you a confirmation email when you signed up!',
    alreadyValidated: 'If you have already validated your account, you can click the "Continue" button.',
    clickLinkInEmail: 'Otherwise, click the link in the email to validate your account, then come back to this page and click the "Continue" button.',
    noEmailReceived: {
      label: 'I did not receive an email',
      content: 'If you did not receive the confirmation email, remember to check your spam; and if you have a Google address, look in the "Promotions" or "Social Networks" tabs. If you cannot find it, you can click the "Resend" button. If you still have not received it after a few minutes,',
      contactSupport: 'contact support',
    },
    continueButton: 'Continue',
    resendButton: 'Resend email',
    resendButtonWithTimer: 'Resend email ({seconds})',
    errors: {
      emailNotValidated: 'Your email has not been validated.',
    },
  },

  // ActivityScore.vue
  activityScore: {
    periodLabel: 'Analysis period',
    periods: {
      allTime: 'All time',
      lastThreeMonths: 'Last three months',
      lastMonth: 'Last month',
    },
    score: 'Score',
    locale: {
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    },
  },

  // ActivityScoreMini.vue
  activityScoreMini: {
    title: 'Activity score',
    messages: {
      connectionHighScore: 'Good! Your regularity is impressive!',
      inactivityLongPause: 'You took a long break, it\'s time to get back to playing!',
      inactivityFrequent: 'You are often inactive, I advise you to be more regular to achieve your goals!',
      playingTimeHigh: 'Impressive! You are doing very good sessions, keep it up.',
      completeLevel: 'Congratulations, you have made tremendous progress! Your score is skyrocketing.',
      completeModule: 'You are on the right track! Keep following the courses.',
      completeSkill: 'You are on the right track! Keep following the courses and unlock skills.',
      completeChallenge: 'One more challenge completed!',
      completePiece: 'Congratulations, you now know how to play one more song!',
      completePiecePart: 'You will soon know how to play one more song!',
      completeBadgeGoal: 'Getting badges will help you achieve your learning goals!',
      default: 'Bravo! Keep it up.',
    },
  },

  // Badges.vue
  badges: {
    title: 'Badges',
    names: {
      regularity: 'Regularity',
      modules: 'Modules',
      pieces: 'Songs',
      challenges: 'Challenges',
      profile: 'Profile',
    },
    levels: {
      playThreeTimesWeek: 'Play three times a week',
    },
  },

  // UserEventsEnum.ts
  userEvents: {
    CONNECTION: 'Connection',
    INACTIVITY: 'Inactivity',
    SEARCH: 'Search',
    COMPLETE_LEVEL: 'Level completed',
    COMPLETE_MODULE: 'Module completed',
    COMPLETE_VIDEO: 'Video watched',
    COMPLETE_EXERCISE: 'Exercise completed',
    COMPLETE_CHALLENGE: 'Challenge completed',
    COMPLETE_PIECE: 'Song completed',
    COMPLETE_PIECE_PART: 'Part completed',
    COMPLETE_SING_PART: 'Singing part completed',
    COMPLETE_PIECE_SING: 'Singing completed',
    COMPLETE_PIECE_CONSOLIDATION: 'Sequence completed',
    COMPLETE_PIECE_SECTION: 'Section completed',
    COMPLETE_SECTION_STEP: 'Step completed',
    COMPLETE_CHECKLIST_STEP: 'Checklist step completed',
    COMPLETE_CHECKLIST: 'Checklist completed',
    PLAYING_TIME: 'Playing time',
    COMPLETE_SKILL: 'Skill validated',
  },

  // UserEventTimeline.vue
  userEventTimeline: {
    title: 'History',
    weekOf: 'Week of',
  },

  // ProgressPage.vue
  progressPage: {
    title: 'Your progress',
    score: 'Score',
    record: 'Record',
    tooltip: 'The goal is to play at least three days each week!',
    pctOfRecord: '{pct}% of record',
    dashboardObjects: {
      activeWeeks: 'Active weeks',
      modules: 'Modules',
      pieces: 'Songs',
      challenges: 'Challenges',
      skills: 'Skills',
    },
    noEvents: {
      title: 'You will soon be able to measure your regularity and progress on piano here, and I will share my analysis to optimize your learning!',
      subtitle: 'But for that, you need to play a little more first.',
      exploreModules: 'Explore skills',
      tryChallenge: 'Try a challenge',
      discoverPieces: 'Discover songs',
    },
    teacherComments: {
      comment1: [
        'Very impressive! By continuing like this you will soon be a piano virtuoso!',
        'Spectacular! With this perseverance, you will become an exceptional pianist.',
        'You are progressing admirably! Continue like this and you will be able to learn your favorite songs in no time!',
      ],
      comment2: [
        'You are on the right track! You could increase your weekly activity a little to accelerate your learning.',
        'Your efforts are paying off! If you increase your playing time a little each week, you will progress even faster.',
        'You can go even further! By slightly increasing your activity, you will see faster progress in your learning.',
      ],
      comment3: [
        'Warning! You are slowing down your progress, take the time to play a little more.',
        'Be careful not to lose speed! Play a little more often so as not to slow down your learning.',
        'Keep an eye on your pace. Increase your learning time to avoid slowing down your progress.',
      ],
      comment4: [
        'You are making tremendous progress! Keep it up and you will soon be able to play your favorite songs!',
        'Your perseverance is paying off! Don\'t give up, and you will soon be able to play your favorite songs with ease.',
        'You are making excellent progress! If you continue like this, you will soon be able to play the songs you love.',
      ],
      comment5: [
        'Your efforts are paying off! Don\'t give up and increase the pace a little to optimize your learning.',
        'You are reaping the benefits of your work! Maintain this intensity and slightly increase your pace to maximize your progress.',
        'Keep persevering! Slightly increase your activity to further accelerate your piano learning.',
      ],
      comment6: [
        'Try to improve your regularity and increase your activity to accelerate your piano learning.',
        'Working on your regularity and increasing your practice time will help you progress faster in piano learning.',
        'Seek to be more consistent in your practice and increase the frequency of playing to accelerate your progress.',
      ],
      comment7: [
        'You are starting very strong! I see great potential in you, keep it up!',
        'Your beginnings are promising! Keep this energy, and you will go far in piano learning.',
        'You are starting very well! I see enormous potential in you, continue on this path!',
      ],
      comment8: [
        'It\'s a good start! Slightly increase your activity to achieve optimal progression!',
        'You are off to a good start! By increasing your activity a little, you will see your learning accelerate.',
        'You have started well! For optimal progression, consider slightly increasing your practice time.',
      ],
      comment9: [
        'You still have many things to discover! Follow the lessons, learn songs and challenge yourself with challenges!',
        'Your musical journey is just beginning! Explore more by following lessons, learning new songs and taking on challenges!',
        'There is still so much to explore! Continue following lessons, mastering new songs and taking on other challenges!',
      ],
    },
  },

  // ActivityScoreRecap.vue
  activityScoreRecap: {
    title: 'Activity score',
    messages: {
      goodSessionWithRegularity: 'Bravo for your great session {date}, keep it up to make good progress!',
      goodSessionWithoutRegularity: 'Bravo for your great session {date}, try to play more regularly to optimize your progress.',
      scoreDecreasedLow: 'Your activity score has decreased since your last session, let\'s make it go back up!',
      scoreDecreasedMedium: 'Happy to see you again! Try to work with Tokatab more often to make good progress.',
      scoreDecreasedHigh: 'Happy to find you again! I will make you progress on piano after this long break.',
      scoreDecreasedVeryHigh: 'You took a long break, you\'re lucky I still have time slots!',
      smallBreak: 'Happy to see you again! You took a small break, but nothing serious, we will continue to work!',
      completeLevel: 'Congratulations, you have passed an important milestone by validating a level!',
      completePiece: 'Congratulations, it was a pleasure to make you work on a whole song. Feel free to send us a video of you playing it.',
      completeModulesPlural: 'Bravo for the latest validated modules. Let\'s continue on this momentum.',
      completeModuleSingular: 'Bravo for the latest validated module. Let\'s continue on this momentum.',
      completeSkillsPlural: 'Bravo for the latest validated skills. Let\'s continue on this momentum.',
      completeSkillSingular: 'Bravo for the latest validated skill. Let\'s continue on this momentum.',
      completeChallengesAndParts: 'Bravo, you have completed {challenges} and {parts}. Keep it up!',
      completeChallengesAndSections: 'Well done, you have completed {challenges} and {sections}.',
      completeChallengesAndExercises: 'Well done, you have completed {challenges} and {exercises}.',
      completePartsAndExercises: 'Wow, great session! You have completed {parts} and {exercises}. Keep it up!',
      completeParts: 'Happy to work on a song with you! {parts} completed in addition. Keep it up!',
      completeSectionsAndExercises: 'Wow, great session! You have completed {sections} and {exercises}. Keep it up!',
      completeExercises: 'Very good! You have completed {exercises}. Keep it up!',
      completeSections: 'Very good! You have completed {sections}. Continue on this momentum!',
      completeChallenges: 'Great! You have completed {challenges}.',
      playingTimeHigh: 'Very good session! You worked well, keep it up.',
      playingTimeRegular: 'Keep it up and you will improve.',
      connectionHighScore: 'Good! Your regularity is impressive!',
      default: 'Bravo! Keep it up.',
      challenge: '{count} challenge',
      challenges: '{count} challenges',
      exercise: '{count} exercise',
      exercises: '{count} exercises',
      part: '{count} part',
      parts: '{count} parts',
      section: '{count} section',
      sections: '{count} sections',
    },
  },

  // Components partagés
  profileSettings: {
    save: 'Save',

    // MySubscriptionSetting.vue
    subscription: {
      title: 'My subscription',
      yourSubscription: 'Your Subscription',
      viaAppStore: 'Via the App Store',
      appStoreManagement: 'Go to the App Store to manage your subscription or contact our support:',
      type: 'Type:',
      price: 'Price:',
      premiumMemberSince: 'Premium member since',
      alphaBetaMemberSince: 'Alpha/beta member since',
      trialEndDate: 'End of trial period on',
      noActivePremium: 'No active premium subscription',
      restorePurchases: 'Restore subscriptions',
      subscribe: 'Subscribe',
      manageSubscription: 'Manage my subscription',
      weeklyFreeActionsRemaining: 'You have {count}/{total} content remaining this week.',
      dailyFreeActionsRemaining: 'You have {count}/{total} content remaining for today.',
      weeklyFreeTeacherMessagesRemaining: 'You have {count}/{total} messages with the teacher remaining this week.',
      subscriptionRestored: 'Subscription restored successfully!',
      noActiveSubscriptionFound: 'No active subscription found, a problem? Contact support.',
    },

    // GoalPickerSetting.vue
    goals: {
      title: 'My goals',
    },

    // SelectMaterialSetting.vue
    material: {
      title: 'My equipment',
      updated: 'Your equipment has been updated',
    },

    // SelectDisplayModeSetting.vue
    displayMode: {
      title: 'Display mode',
      updated: 'Your display mode has been updated',
    },

    // LevelSetting.vue
    level: {
      title: 'Level',
      currentLevel: 'For now you have the level:',
      changeLevel: 'Change level',
      retakeTest: 'Retake level test',
    },

    // HandSizeSetting.vue
    handSize: {
      title: 'Hand size',
      notTested: 'You have not taken the test yet.',
      takeTest: 'take the test',
      retakeTest: 'retake the test',
    },

    // SingerProfileSetting.vue
    voice: {
      title: 'My voice',
      myVoice: 'My Voice',
      notTested: 'You have not taken the test yet!',
      singerNotice: 'Feel free to measure your vocal range with our test so that Tokatab can later suggest songs in a key adapted to your voice.',
      takeTest: 'Take the test',
      retakeTest: 'Retake the test',
      voiceTypes: {
        bass: 'Bass',
        baritone: 'Baritone',
        tenor: 'Tenor',
        alto: 'Alto',
        mezzo: 'Mezzo',
        soprano: 'Soprano',
      },
    },

    // SessionNotificationsSetting.vue
    scheduledSessions: {
      title: 'Scheduled sessions',
      subtitle: '',
      description1: 'We think that one of the keys to progress is regularity!',
      description2: 'That\'s why you can schedule reminders for your piano sessions!',
    },

    // SelectCapgoChannel.vue
    capgoChannel: {
      title: 'Change capgo channel',
      error: 'Error changing channel.',
    },
  },

  // SubscriptionButton.vue
  subscriptionButton: {
    tryTokatabPremium: 'Try Tokatab Premium',
    tokatabPremium: 'Tokatab Premium',
  },
};